require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/$.core').Object.setPrototypeOf;


//////////////////
// WEBPACK FOOTER
// /Users/frontend-dev/Desktop/ESM/elit_stroy_front/~/babel-runtime/~/core-js/library/fn/object/set-prototype-of.js
// module id = 57
// module chunks = 0